import { Amplify, Auth, Hub, Logger } from 'aws-amplify';

export type HubPayload = {
    event: string,
    data?: any,
    message?: string
};
 
      // Dev account:
        // Auth: {
        // identityPoolId: 'us-west-2:7256369b-1cfe-4cd2-b3b0-e52d2fe0e79b', // REQUIRED - Amazon Cognito Identity Pool ID
        // region: 'us-west-2', // REQUIRED - Amazon Cognito Region
        // userPoolId: 'us-west-2_gmqURUgxs', // OPTIONAL - Amazon Cognito User Pool ID
        // userPoolWebClientId: '7f1kt8dalub0idm98ina2s627j', // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
        // },
        // Staging account:
        // Auth: {
        //   identityPoolId: 'us-west-2:67a52b49-3e35-4170-af1e-4e00807e329c', // REQUIRED - Amazon Cognito Identity Pool ID
        //   region: 'us-west-2', // REQUIRED - Amazon Cognito Region
        //   userPoolId: 'us-west-2_KtSQKaoYi', // OPTIONAL - Amazon Cognito User Pool ID
        //   userPoolWebClientId: '3si039evs4km4046pgg3pujis3', // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
        //   },

const ConfigureAmplify = () => {

    Amplify.configure({
        Auth: {
          identityPoolId: process.env.REACT_APP_ID_POOL_ID, //'us-west-2:67a52b49-3e35-4170-af1e-4e00807e329c', // REQUIRED - Amazon Cognito Identity Pool ID
          region: 'us-west-2', // REQUIRED - Amazon Cognito Region
          userPoolId: process.env.REACT_APP_USER_POOL_ID, //'us-west-2_KtSQKaoYi', // OPTIONAL - Amazon Cognito User Pool ID
          userPoolWebClientId: process.env.REACT_APP_CLIENT_ID, //'3si039evs4km4046pgg3pujis3', // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
          },
        API: {
          aws_appsync_graphqlEndpoint: process.env.REACT_APP_API_URL, //'https://7aulmygcfbbjlnx4qclzp5rw4a.appsync-api.us-west-2.amazonaws.com/graphql',
            // aws_appsync_graphqlEndpoint: 'https://wbshzfnzsreetdzosy576hrodu.appsync-api.us-west-2.amazonaws.com/graphql',
            //graphql_endpoint: 'https://5nzyioyhcrdwffjxtz7yjbo4xq.appsync-api.us-west-2.amazonaws.com/graphql',
            aws_appsync_region: 'us-west-2',
            aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
            endpoints: [
                {
                    name: "esc-api",
                    endpoint: "https://o1lh3vd5dc.execute-api.us-west-2.amazonaws.com", //"https://5z5p9kh4q3.execute-api.us-west-2.amazonaws.com",
                    custom_header: async () => {
                    //return { Authorization: 'token' };
                    // Alternatively, with Cognito User Pools use this:
                    // return { Authorization: `Bearer ${(await Auth.currentSession()).getAccessToken().getJwtToken()}` }
                    return { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` }
                    },
                },
            ]
        },
        Storage: {
          AWSS3: {
              bucket: 'esc-testdata-dev', //REQUIRED -  Amazon S3 bucket name
              region: 'us-west-2', //OPTIONAL -  Amazon service region
          },
          customPrefix: {
            public: 'public/',
            protected: 'sessions/',
            private: 'sessions/'
          },      
        },
        geo: {
          AmazonLocationService: {
            search_indices: {
              items: ["EsteamCloud-locationIndex-dev"], // REQUIRED - Amazon Location Service Place Index name
              default: "EsteamCloud-locationIndex-dev", // REQUIRED - Amazon Location Service Place Index name to set as default
            },
             region: 'us-west-2', // REQUIRED - Amazon Location Service Region
          },
        },
    });

    // Hub.listen('auth', (data) => {
    //     const { payload } = data;
    //     console.log('A new auth event has happened: ', payload);
    // });
    Hub.listen('api', (data) => {
        const { payload } = data;
        console.log('A new API event has happened: ', payload);
    });
    
    const logger = new Logger('My-Logger');

const listener = (data: any) => {
    console.log("Auth event:",data.payload, data)
  switch (data.payload.event) {
    case 'configured':
      logger.info('the Auth module is configured');
      break;
    case 'signIn':
      logger.info('user signed in');
      break;
    case 'signIn_failure':
      logger.error('user sign in failed');
      break;
    case 'signUp':
      logger.info('user signed up');
      break;
    case 'signUp_failure':
      logger.error('user sign up failed');
      break;
    case 'confirmSignUp':
      logger.info('user confirmation successful');
      break;
    case 'completeNewPassword_failure':
      logger.error('user did not complete new password flow');
      break;
    case 'autoSignIn':
      logger.info('auto sign in successful');
      break;
    case 'autoSignIn_failure':
      logger.error('auto sign in failed');
      break;
    case 'forgotPassword':
      logger.info('password recovery initiated');
      break;
    case 'forgotPassword_failure':
      logger.error('password recovery failed');
      break;
    case 'forgotPasswordSubmit':
      logger.info('password confirmation successful');
      break;
    case 'forgotPasswordSubmit_failure':
      logger.error('password confirmation failed');
      break;
    case 'tokenRefresh':
      logger.info('token refresh succeeded');
      break;
    case 'tokenRefresh_failure':
      logger.error('token refresh failed');
      break;
    case 'cognitoHostedUI':
      logger.info('Cognito Hosted UI sign in successful');
      break;
    case 'cognitoHostedUI_failure':
      logger.error('Cognito Hosted UI sign in failed');
      break;
    case 'customOAuthState':
      logger.info('custom state returned from CognitoHosted UI');
      break;
    case 'customState_failure':
      logger.error('custom state failure');
      break;
    case 'parsingCallbackUrl':
      logger.info('Cognito Hosted UI OAuth url parsing initiated');
      break;
    case 'userDeleted':
      logger.info('user deletion successful');
      break;
    case 'signOut':
      logger.info('user signed out');
      break;
    default:
        logger.info('unknown auth message')
  }
};
Hub.listen('auth', listener);
    

};

export default ConfigureAmplify
